import React from "react";

import { Leaf } from "./Leaf";

import { LibraryItem } from "../../../entities/LibraryItem";

export interface Props {
	folderLibraryItems: LibraryItem[];
	parentId: string | null;
	onSelect: (folderLibraryItemId: string) => void;
	level: number;
	focusedId: string;
}

export function TreeBranch(props: Props) {
	const { folderLibraryItems, parentId, level, focusedId } = props;

	const recurse = (existingFolders: LibraryItem[]) => {
		let folders: LibraryItem[] = [];

		for (let i = existingFolders.length - 1; i >= 0; i--) {
			let folder = existingFolders[i];
			if (folder.parentId === parentId) {
				// this is the current directory
				folders.push(folder);
				existingFolders.splice(i, 1);
			}
		}

		return (
			<span key={parentId + "tree"}>
				{folders.map((item: LibraryItem, index: number) => (
					<Leaf
						key={item.id + item.parentId +  index}
						existingFolders={existingFolders}
						item={item}
						onSelect={props.onSelect}
						level={level}
						focusedId={focusedId}
					/>
				))}
			</span>
		);
	};

	if (folderLibraryItems.length === 0) {
		return null;
	}

	return recurse([...folderLibraryItems]);
}
